export const FooterNavItems = [
  {
    href: "https://spartacodingclub.kr",
    text: "스파르타코딩클럽",
  },
  {
    href: "https://hanghae99.spartacodingclub.kr/",
    text: "항해99",
  },
  {
    href: "https://chang.spartacodingclub.kr/",
    text: "{창}",
  },
  {
    href: "https://spartacodingclub.kr/nb",
    text: "국비지원교육",
  },
  {
    href: "https://spartacodingclub.kr/b2b",
    text: "기업교육",
  },
  {
    href: "https://intellipick.spartacodingclub.kr",
    text: "인텔리픽",
  },
];

// export const nbFooterNavItems = [
//   {
//     text: "HOME",
//     href: "/",
//   },
//   {
//     text: "스파르타코딩클럽",
//     href: "/",
//   },
//   // {
//   //     text: '내일배움단 플러스',
//   //     href: 'https://sparta-nb-new.oopy.io'
//   // },
// ];

export const FooterSNSItems = [
  {
    href: "https://m.blog.naver.com/PostList.nhn?blogId=spartacoding&categoryNo=6&logCode=0&categoryName=%EC%88%98%EA%B0%95%EC%83%9D%C2%A0%EC%86%94%EC%A7%81%ED%9B%84%EA%B8%B0",
    text: "naver",
    img: "/images/footer/n_f_sns_naver.png",
  },
  {
    href: "https://spartacodingclub.tistory.com",
    text: "tistory",
    img: "/images/footer/n_f_sns_tistory.png",
  },
  {
    href: "https://www.instagram.com/spartacodingclub",
    text: "insta",
    img: "/images/footer/n_f_sns_insta.png",
  },
  {
    href: "https://www.youtube.com/channel/UC2Fh3XoQYNYTba-cigq5cAA",
    text: "youtube",
    img: "/images/footer/n_f_sns_youtube.png",
  },
];

export const FooterInfoFirstLineItems = [
  {
    href: "https://forms.gle/4kPLDbR8vVcvKVpd7",
    text: "튜터",
  },
  {
    href: "https://career.spartacodingclub.kr/",
    text: "채용",
  },
  {
    href: "https://sparta-career-b2b.oopy.io/",
    text: "협력사 지원",
  },
  {
    href: "https://swjungle.net",
    text: "SW사관학교 정글",
  },
];

export const FooterInfoSecondLineItems = [
  {
    href: "https://teamsparta.notion.site/7b1dc644460946f08bab08b794de685f",
    text: "개인정보처리방침",
  },
  {
    href: "https://teamsparta.notion.site/247d57da1322424d8e8c551df21a048e",
    text: "서비스 이용약관",
  },
  {
    href: "https://teamsparta.notion.site/SW-e6522b3030654dcc96077080eab9076c",
    text: "환불 규정",
  },
  {
    href: "https://swcamp.oopy.io/9b824818-ac8e-466a-8b9c-bf7281f0fef1",
    text: "자주묻는질문",
  },
];

export const InfoDropDownText = "팀스파르타(주) 사업자 정보";
export const InfoDropDownIconImg = "/icons/drop_down_icon.png";

export const BusinessInfoItems = [
  {
    title: "대표자:",
    value: "이범규",
  },
  {
    title: "사업자 등록번호:",
    value: "783-86-01715",
  },
  {
    title: "통신판매업 신고번호:",
    value: "2020-서울강남-02300",
  },
  {
    href: "https://drive.google.com/file/d/1xtT3BX_uowATTC7X788a0EYYTkVx551r/view?usp=sharing",
    value: "평생교육시설 신고번호: 제 661호",
  },
  {
    title: "주소:",
    value: "서울특별시 강남구 테헤란로44길 8 12층",
  },
  {
    title: "이메일:",
    value: "contact@teamsparta.co",
  },
  {
    title: "화상",
    value: "1522-8016",
  },
];

export const CopyRightText = "Copyright ©2022 TEAMSPARTA. All rights reserved.";
